export const COMPANY = {
  name: "Nago International",
  tagline: "Where Industrial Performance Meets Dependable Supply",
  slogan: "Powering industry with reliable supply, precision products, and trusted partnerships.",
  since: 2016,
  address:
    "CTS No. 494, R.S. No. 347/2, Industrial Estate, Udyambag, Belagavi – 590008, Karnataka, India",
  phones: ["+91 98449 68487", "+91 96069 46650"],
  whatsapp: "+91 96069 46650",
  whatsappLink: "https://wa.me/919606946650",
  email: "nagointernational@gmail.com",
  website: "www.nagointernational.com",
  hours: "Monday – Saturday, 9:00 AM – 6:00 PM",
  mapsLink: "https://maps.app.goo.gl/Z82BC4TvYd9xZr5b9",
  mapsEmbed:
    "https://www.google.com/maps?q=Industrial+Estate+Udyambag+Belagavi&output=embed",
  gstin: "29BNGPP3594N2Z1",
  udyam: "UDYAM-KR-04-0035617",
  stats: [
    { value: "Since 2016", label: "Trusted supplier" },
    { value: "10+", label: "Authorized brands" },
    { value: "12+", label: "Product categories" },
    { value: "Pan-India", label: "Supply reach" },
    { value: "GST · Udyam", label: "Registered" },
  ],
};

export const VALUES = [
  "Integrity",
  "Quality",
  "Customer Commitment",
  "Reliability",
  "Innovation",
  "Excellence",
  "Partnership",
];
